<template>
   <div class="card">
      <h6>CONFIRM & SWITCH</h6>
      <ul class="bullet-points _margin-bottom-30">
         <li>You will recieve a confirmation of your application to switch.</li>
         <li>Your application to switch will be sent to {{ switchPlan.supplierName }}.</li>
         <li>{{ switchPlan.supplierName }} will get in touch with you to tell you the date when your switch will take place. It can take up to 5 to 10 working days.</li>
         <li>Take a final meter reading on the day of your switch</li>
         <li>Remember to pay your final bill to your old energy supplier</li>
      </ul>

      <p>
         Your cancellation rights are stated in the supplier's terms and conditions so please read these in full should you wish to do so.
         For clarity please note that the period during which you have a right to cancel your energy contract (cooling off period) expires 14
         days from the date on which you receive your welcome pack from <b>{{ switchPlan.supplierName }}</b>.
      </p>

      <p>
         By selecting <b>'Complete Switch'</b> you are confirming that it is your intention to transfer your supply of energy over to the new
         supplier selected and that you have read the terms and conditions. You are also confirming that you understand your obligations
         to pay for your energy in accordance with the supplier's terms and conditions and at the prices outlined in the Tariff Information Label.
         For more information please see sections 14 and 30 of <a href="https://www.legislation.gov.uk/uksi/2013/3134/made" target="_blank">The Consumer Contracts Regulations 2013</a>
      </p>

      <div class="form-group _margin-bottom-20">
         <div class="col-md-10">
            <!-- <validation-messages label="Terms & Conditions Agreement">
                  <checkbox id="termsAndConditions"
                  v-model="terms.suppliersTermsAndConditionsAreAccepted">
                  Yes, I accept the energy supplier <a target="_blank" :href="switchPlan.supplierTosUrl">term's and conditions</a>
               </checkbox>
            </validation-messages> -->
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Confirm',
  props: {
    $form: Object
  },
  computed: {
    ...mapState({
      app_settings: ({ app_settings }) => app_settings,
      switchPlan: ({ personal_details_switch_plan }) => personal_details_switch_plan
    })
  }
};
</script>

<style lang="scss"></style>
